const KACHING_SELECTORS = [
  '[data-bundle-total]',
  '[data-total]',
  '[data-price]',
  '.kaching-bundles-total',
  '.kaching-bundles__total',
  '[class*="kaching"][class*="total"]',
  '[class*="kaching"][class*="price"]',
];

const PRICE_REGEX = /[$£€][\d,]+\.?\d*\s*(USD|CAD|EUR|GBP)?/i;

/**
 * Finds the bundle total price string within a container element.
 * @param {Element | null} container - The DOM container to search
 * @returns {string | null} The price string (e.g. "$99.99") or null
 */

function findBundleTotal(container) {
  if (!container) {
    return null;
  }
  for (const sel of KACHING_SELECTORS) {
    const el = container.querySelector(sel);
    if (el) {
      const val = el.dataset?.bundleTotal ?? el.dataset?.total ?? el.dataset?.price ?? el.textContent?.trim();
      if (val && PRICE_REGEX.test(val)) {
        return val;
      }
    }
  }
  const walk = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const match = node.textContent?.match(PRICE_REGEX);
      if (match) {
        return match[0];
      }
    }
    for (const child of node.childNodes || []) {
      const result = walk(child);
      if (result) {
        return result;
      }
    }
    return null;
  };
  return walk(container);
}

function updateSlots(price) {
  const slots = document.querySelectorAll('[data-bundle-total-slot]');
  const suffix = price ? ` - ${price}` : '';

  for (const slot of slots) {
    slot.textContent = suffix;
  }
}

if (!customElements.get('kaching-bundle-atc-sync')) {
  customElements.define(
    'kaching-bundle-atc-sync',
    class KachingBundleAtcSync extends HTMLElement {
      constructor() {
        super();
        this.observer = null;
        this.kachingObserver = null;
      }

      connectedCallback() {
        this.tryAttach();
        this.observer = new MutationObserver(() => this.tryAttach());
        this.observer.observe(document.body, { childList: true, subtree: true });
      }

      tryAttach() {
        const kaching = document.querySelector('.kaching-bundles');
        if (!kaching || this.kachingObserver) {
          return;
        }
        const sync = () => {
          const total = findBundleTotal(kaching);
          updateSlots(total);
        };
        sync();
        this.kachingObserver = new MutationObserver(sync);
        this.kachingObserver.observe(kaching, { childList: true, subtree: true, characterData: true, characterDataOldValue: true });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.kachingObserver?.disconnect();
      }
    },
  );
}
